module.exports = __webpack_public_path__ + "2f8abc6989d44a3379781f71fea205a0.fbx";